export default __webpack_public_path__ + "static/media/tracking_selected.27f86bcd.svg";